// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","Header":"Modal_Header__3TAv2","Close":"Modal_Close__1SpUE","Title":"Modal_Title__3n2Ph","Body":"Modal_Body__484CJ"};